

exports.__esModule = true;
exports.$xoFrameBustPageDirective = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _logger = require('xo-beaver/dist/logger');

var _uiRouter = require('uiRouter');

var _index = require('squid/index');

var _icFallback = require('js/lib/icFallback');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoFrameBustPageDirective = exports.$xoFrameBustPageDirective = _index.$Component.extend('$xoFrameBustPageDirective', {

    tag: 'xo-framebust-page',
    template: _template2['default'],

    props: {},

    resolve: {},

    actions: {
        submit: function submit() {

            window.xchild.hide();

            var url = decodeURIComponent(_uiRouter.$stateParams.url);

            if (_uiRouter.$stateParams.action === 'open') {

                var xprops = _extends({}, window.xprops);

                xprops.url = url;

                _logger.$logger.warn('framebust_click_to_hermes');

                return window.ppxo.Checkout.renderPopupTo(window.xchild.getParentRenderWindow(), xprops);
            }

            if (_uiRouter.$stateParams.action === 'fallback') {

                var _xprops = _extends({}, window.xprops);
                _xprops.url = url;
                _xprops.dimensions = {
                    width: 970,
                    height: 850
                };

                var component = window.ppxo.Checkout.init(_xprops);

                _logger.$logger.warn('framebust_click_to_legacy');

                component.renderTo(window.top, null, 'popup');

                (0, _icFallback.$incontextFallback)(component.window, url);
            }
        }
    }
});

angular.value("$xoFrameBustPageDirective", $xoFrameBustPageDirective);
_logger.$logger;

_uiRouter.$stateParams;

_index.$Component;

_icFallback.$incontextFallback;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-framebust/directive.js
// module id = ./pages/xo-framebust/directive.js
// module chunks = 1